import type { IconProps } from '../types/IconProps.ts';
export const RefreshCw: IconProps = {
    name: 'RefreshCw',
    children: [
        `<path d="M19.48 6.77a10.5 10.5 0 0 0-5.94-3.63 9 9 0 0 0-10.48 7.23M20.9 11.61q.05 1-.14 2a9 9 0 0 1-10.48 7.23C7.22 20.28 5.15 17.66 4 15" />`,
        `<path d="M8 14H3.5a.5.5 0 0 0-.5.5V19M20 3v4.5a.5.5 0 0 1-.5.5H15" />`,
    ]
};